import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { ConfigService } from '../config.service';
import { BehaviorSubject, Subscriber } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AESService } from '../encryption/aes.service';

const httpOptions = {
  headers: new HttpHeaders({ 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json', })
};

@Injectable(

)
export class LoginService {
  dataofpermissions = new BehaviorSubject('');
  constructor(public http: HttpClient, public config: ConfigService, private CryptoService: AESService) {
  }
  signin(user: any): Observable<any> {
    return this.http.post<any>(this.config.baseURL + '/user/login', user, httpOptions)
      .map((res) => {
        // this.dataofpermissions.next(res.data.Role.rolepermission)
        return res
      }
    );
  }

  loginWithClientPortal(): Observable<any> {
    const enc = this.CryptoService.encrypt({ email: environment.ableAdminEmail, password: environment.ableAdminPassword });
    const body = { data: enc }
    return this.http.post<any>(environment.baseUrlClientPortal + '/ableUser/loginAdmin', body)
      .map((res) => {
        // this.dataofpermissions.next(res.data.Role.rolepermission)
        return res
      }

      );
  }
  //  getpermissions(){
  //    return this.dataofpermissions
  //   }
}
